<template>
  <div>
    <div
      class="switch-class-row rounded-5 white w-100 h-auto pointer"
      @click="updateCurrentClass"
    >
      <!-- CLASS LABEL -->
      <div class="switch-class-label" :class="setLabelBg"></div>

      <!-- CLASS INFO -->
      <div class="d-flex justify-content-between align-items-center nowrap">
        <!-- CLASS NAME -->
        <div class="switch-class-name color_text">{{ class_name }}</div>

        <!-- SELECT OPTION -->
        <div class="select-option" v-if="selected">
          <div class="done"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { colors, shuffle, random } from "@/scripts/utilities";
import { mapActions } from "vuex";

export default {
  name: "SwitchClassRow",

  props: {
    class_id: Number,
    class_name: String,
    selected: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    setLabelBg() {
      let shuffled = shuffle(colors);
      return shuffled[random(11, 0)];
    },
  },

  methods: {
    ...mapActions(["setCurrentClass"]),

    updateCurrentClass() {
      this.setCurrentClass(this.class_id);
      this.$emit("updateClass", this.class_id);
      this.$router.push({
        name: this.$router.currentRoute.name,
        params: { id: this.class_id },
      });
    },
  },
};
</script>

<style lang="scss">
.switch-class-row {
  position: relative;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
  margin-bottom: 5px;
  padding: 16px 24px;
  overflow: hidden;
  transition: all 0.4s ease-in-out;

  @include breakpoint_max(sm) {
    padding: 11px 18px;
  }

  &:hover {
    transform: scale(0.98);
  }

  .switch-class-label {
    position: absolute;
    top: 0;
    left: 0;
    width: 6px;
    height: 100%;

    @include breakpoint_max(sm) {
      width: 5px;
    }

    @include breakpoint_max(xs) {
      width: 4.5px;
    }
  }

  .switch-class-name {
    font-size: 14px;
    line-height: 19px;

    @include breakpoint_max(sm) {
      font-size: 12px;
      line-height: 19px;
    }
  }

  .done {
    @include equal_min_edge(20);
    &:after {
      font-size: 13px;
    }
  }
}
</style>
